import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Container } from "react-bootstrap";

import { messageApi, simReportApi } from "../../utility/api/apiList";
import { showModalAlert } from "../../redux/actions/alert/alertActions";

import useAxios from "../../hooks/useAxios";

import { TabContentSection } from "../../containers/singleSim/styledSimContainer";
import { editorContent } from "../../containers/singleSim/labReport";
import ActivityTab from "../../components/public/singleSimTabs/activityTab";
import TeacherFeedBackModal from "./teacherFeedBackModal";

const SingleSimReport = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const simReportData = location.state?.report;
  const loading = location.state?.loading;
  const editorData = editorContent(simReportData?.sim_report);

  const {
    data: labReportData,
    isLoaded: labReportDataIsLoaded,
    error: labReportError,
    run: labReportDataRun,
  } = useAxios({
    url: `${simReportApi}${simReportData?.sim_report.id}/`,
    params: {
      type: "student",
    },
  });

  const { isLoading: feedBackLoading, run: feedBackRun } = useAxios({
    url: messageApi,
    method: "post",
  });

  useEffect(() => {
    labReportDataRun();
  }, []);

  const openSendActivityModal = () => {
    dispatch(
      showModalAlert({
        maxWidth: "530px",
        backdrop: true,
        content: (
          <TeacherFeedBackModal
            feedBackRun={feedBackRun}
            isLoading={loading}
            loading={feedBackLoading}
            messageData={simReportData}
          />
        ),
      })
    );
  };
  return (
    <Container className="py-5">
      <TabContentSection className="mx-2 mx-md-5 py-4 px-md-3">
        <ActivityTab
          teacherFeedBack={true}
          editorContent={editorData}
          simReportData={labReportData}
          isLoaded={labReportDataIsLoaded}
          error={labReportError}
          uploadedImages={labReportData?.image}
          openSendActivityModal={openSendActivityModal}
          loading={feedBackLoading}
        />
      </TabContentSection>
    </Container>
  );
};

export default SingleSimReport;
